import { useState } from "react";
import { Dropdown, DropdownToggle} from 'reactstrap';


/**
 * @module components/LnDropDownMenu
 * @return A dropdown menu component.
 * @param {{ className?: string, children: any, caret:any, toggleComponent: any, toogleClassName: string, toogleTagName:any, direction?: import("reactstrap/lib/Dropdown").Direction }} props
 */
const LnDropDownMenu = (props) => {
    const { className, children, caret, toggleComponent, toogleClassName, toogleTagName, direction } = props;
    const [dropdownOpen, setOpen] = useState(false);
    const toggle = () => setOpen(!dropdownOpen);

    const dir = direction || "down" as import("reactstrap/lib/Dropdown").Direction;

    return (
        <Dropdown className={className} a11y={false} direction={dir} isOpen={dropdownOpen} toggle={toggle} >
            <DropdownToggle caret={caret} className={toogleClassName} tag={toogleTagName}>
                {toggleComponent}
            </DropdownToggle>
            {children}
        </Dropdown >
    )
};


export default LnDropDownMenu;